/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ZoneQuery = {
  /**
   * Filter zones by name
   */
  name?: string;
  /**
   * Filter zones by type
   */
  type?: ZoneQuery.type;
  /**
   * Client current timezone offset in minutes. Is required.
   */
  timezoneOffset?: number;
  /**
   * Page Size. Default: 25
   */
  limit?: number;
  /**
   * Offsetting x items. Default: 0
   */
  offset?: number;
  /**
   * Sort by. Default: id
   */
  sortBy?: string;
  /**
   * Sort order descendent. Default: true
   */
  sortDesc?: boolean;
  /**
   * Sort with locale. Default: sk
   */
  sortLocale?: string;
};
export namespace ZoneQuery {
  /**
   * Filter zones by type
   */
  export enum type {
    SIMPLE = 'SIMPLE',
    COMBINED = 'COMBINED',
    ALL_NETWORK = 'ALL_NETWORK',
  }
}
